import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import Icon from 'ui/components/Icon'
import { Row, DragHandle, RowContent } from './styled'

export default function ChecklistSortableRow({
  id,
  children,
  disabled = false,
  ...rest
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    willChange: 'transform',
    position: disabled ? 'relative' : undefined,
    zIndex: disabled ? 10000 : undefined,
  }

  return (
    <Row
      ref={setNodeRef}
      style={style}
      data-row
      data-dragging={isDragging ? 'true' : 'false'}
      {...rest}
    >
      <DragHandle {...attributes} {...listeners}>
        <Icon name="drag" size={16} />
      </DragHandle>
      <RowContent>{children}</RowContent>
    </Row>
  )
}
